/**
 * Created by karel on 09/06/16.
 */
module.exports.SymbolTerminalToolController    = require("./extensions/symbolTerminalTool/symbolTerminalToolController.js");
module.exports.SymbolTerminalViewerController  = require("./extensions/symbolTerminalViewer/symbolTerminalViewerController.js");
module.exports.SymbolGeneratorToolController   = require("./extensions/symbolGeneratorTool/symbolGeneratorToolController.js");
module.exports.SymbolGeneratorViewerController = require("./extensions/symbolGeneratorViewer/symbolGeneratorViewerController.js");
module.exports.SymbolSettingsController        = require("./extensions/symbolSettings/symbolSettingsController");

module.exports.PropertyToolController = require("./../shared/extensions/propertyTool/propertyToolController.js");
module.exports.PropertyViewerController = require("./../shared/extensions/propertyViewer/propertyViewerController.js");